export const ITEMS_PER_PAGE = 10
export const SCROLL_POSITION_KEY = 'customerListingScrollPosition'
export const CUSTOMERS_DATA_KEY = 'customerListingData'
export const PRESERVE_CUSTOMER_LISTING_KEY = 'preserveCustomerListingState'
export const CUSTOMER_LISTING_INPUT_KEY = 'customerListingInput'
